import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { GalleryService } from '../../services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryResolve {
  constructor(private galleryService: GalleryService) {}

  async resolve(next: ActivatedRouteSnapshot) {
    try {
      return await this.galleryService.getPublicGalleryFromSnapshot(next, { isPublic: true });
    } catch (err) {
      console.error(err);
    }
  }
}
